import dayjs from 'dayjs'

export const calculateMenteeBar = (
  hour: string,
  startHour: string,
  endHour: string,
  isVacation: boolean
): { height: string; padding: string } => {
  const differenceInMinutes = dayjs(endHour, 'HH:mm').diff(dayjs(startHour, 'HH:mm'), 'minute')
  const fullHoursBetween = parseInt(endHour.split(':')[0], 10) - parseInt(startHour.split(':')[0], 10) + 1

  const height = isVacation ? 45 * 24 + 'px' : differenceInMinutes * (44 / 60) + fullHoursBetween + 'px'
  const padding = dayjs(startHour, 'HH:mm').diff(dayjs(hour, 'HH:mm'), 'minute') * (44 / 60) + 'px'

  return { height, padding }
}